import React, { useState, useRef, useEffect } from 'react';
import { Button, Card, CardBody, Row, Table, Col, Progress } from 'reactstrap';
import { IconButton, CircularProgress } from '@mui/material';
import BackupIcon from '@mui/icons-material/BackupOutlined';
import firebase from 'firebase';
import CloseIcon from '@mui/icons-material/Close';
import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config';
import algoliasearch from 'algoliasearch/lite';
import { algoliaAppID, algoliaSearchID } from '../../Utilities/algoliaKeys';
import SearchIcon from '@mui/icons-material/Search';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useForm } from 'react-hook-form';
import format from 'date-fns/format';
import NotificationAlert from 'react-notification-alert';
import MovieIcon from '@mui/icons-material/Movie';
import api from '../../Utilities/api';
import { FileDrop } from 'react-file-drop';

function MediaDialog({ handleClose, currentData, fetchSubject }) {
  const classes = {
    root: {
      '& :hover': {},
      color: '#FFF',
    },
    dialog: {
      '& .MuiDialogTitle-root': {
        backgroundColor: '#FFF',
        color: '#333333',
      },
      '& .MuiDialogActions-root': {
        backgroundColor: '#FFF',
        color: '#333333',
      },
    },
    dialogBtn: {
      display: 'flex',
      justifyContent: 'space-around',
      backgroundColor: '#FFF',
    },
    title: {
      '& .MuiDialogTitle-root': {
        color: '#333333',
      },
    },
  };
  const [progressVisible, setProgressVisible] = useState(true);
  const [progressValue, setProgressValue] = useState(8);
  const [batchData, setBatchData] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(currentData.batch || []);
  const [selectedBatchCheckbox, setSelectedBatchCheckbox] = useState({});
  const [batchSearchValue, setBatchSearchValue] = useState('');
  const searchClient = algoliasearch(algoliaAppID, algoliaSearchID);
  const batchSearchIndex = searchClient.initIndex('Batch_Search');
  const [currentSubject, setCurrentSubject] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const [batchStudents, setBatchStudents] = useState([]);
  const [fileTitle, setFileTitle] = useState(currentData.fileUrl);
  const [filePath, setFilePath] = useState(
    currentData.fileUrl ? currentData.fileUrl : null
  );
  const [fileUploading, setFileUploading] = useState(false);
  const browseBtnRef = useRef();
  let data = [];
  const notifi = useRef();
  const notify = (msg, err) => {
    let color = err == false ? 'success' : 'danger';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err == false ? 'Success' : 'Error'}</b> - {msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notifi.current.notificationAlert(options);
    }
  };

  const getBatchData = () => {
    db.collection('Batch')
      .where('type', '==', 'batch')
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => doc.data());
        setBatchData(data);
        setProgressVisible(false);
      });
  };

  const removeBatch = (batchId) => {
    setBatchStudents(batchStudents.filter((batch) => batch.id !== batchId));
  };

  const getBatchStudents = (batchId) => {
    db.collection('zSystemStudents')
      .where('batch', 'array-contains', batchId)
      .get()
      .then((query) => {
        query.docs.map((doc) => data.push(doc.data()));
        setBatchStudents([...batchStudents, { id: batchId, data }]);
      });
  };

  const batchSearch = () => {
    if (batchSearchValue === '') {
      notify('Search field can not be empty', true);
      // } else if (batchSearchValue.length < 3) {
      // 	notify("Search atleast 4 words", true);
    } else {
      document.querySelector('#loading-indicator').style.display = 'flex';
      batchSearchIndex
        .search(batchSearchValue, { typoTolerance: false })
        .then((result) => {
          if (result.hits.length === 0) {
            document.querySelector('#loading-indicator').style.display = 'none';
            notify('No results found', true);
          } else {
            document.querySelector('#loading-indicator').style.display = 'none';
            setBatchData(result.hits);
          }
        })
        .catch((err) => {
          document.querySelector('#loading-indicator').style.display = 'none';
          notify(err.toString(), true);
        });
    }
  };

  // --- react-hook-form setup ---
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    defaultValues: {
      title: currentData.title || '',
      lectureSubject: currentData.subjectId || '',
      lectureDate: currentData.lectureDate
        ? format(new Date(currentData.lectureDate), 'yyyy-MM-dd')
        : format(new Date(), 'yyyy-MM-dd'),
      expiryDate:
        currentData.expiryDate ||
        (currentData.expiryDate
          ? format(new Date(currentData.expiryDate), "yyyy-MM-dd'T'HH:mm")
          : ''),
    },
  });

  useEffect(() => {
    reset({
      title: currentData.title || '',
      lectureSubject: currentData.subjectId || '',
      lectureDate: currentData.lectureDate
        ? format(new Date(currentData.lectureDate), 'yyyy-MM-dd')
        : format(new Date(), 'yyyy-MM-dd'),
      expiryDate:
        currentData.expiryDate ||
        (currentData.expiryDate
          ? format(new Date(currentData.expiryDate), "yyyy-MM-dd'T'HH:mm")
          : ''),
    });
    setSelectedBatch(currentData.batch || []);
    // Set selectedBatchCheckbox for edit
    if (currentData && currentData.batch) {
      let temp = {};
      currentData.batch.forEach((item) => {
        temp[item.batchID] = true;
      });
      setSelectedBatchCheckbox(temp);
    }
    setFilePath(currentData.fileUrl ? currentData.fileUrl : null);
    setFileTitle(currentData.fileUrl);
  }, [currentData, reset]);

  const onSubmit = (data) => {
    setIsSaving(true);
    if (fileUploading) {
      setIsSaving(false);
      notify('Please wait till we upload file', true);
      return;
    }
    if (!filePath) {
      setIsSaving(false);
      notify('Please select video file', true);
      return;
    }
    let finalData = {};
    let res;
    if (currentData) {
      res = db.collection('MediaCenter').doc(currentData?.itemID);
    } else {
      res = db.collection('MediaCenter').doc();
    }
    finalData = {
      title: data.title,
      fileUrl: filePath,
      lectureDate: data.lectureDate,
      lectureDateStamp: firebase.firestore.Timestamp.fromDate(new Date(data.lectureDate)),
      expiryDate: data.expiryDate,
      batch: selectedBatch,
      itemID: currentData ? currentData?.itemID : res.id,
      type: 'Active',
      subjectId: data.lectureSubject,
      isSubjectId: data.lectureSubject ? true : false,
      createdAt: currentData
        ? currentData?.createdAt
        : firebase.firestore.FieldValue.serverTimestamp(),
    };
    res
      .set(finalData, { merge: true })
      .then(() => {
        if (currentData) {
          notify('Media Link updated successfully', false);
        } else {
          notify('Media Link added successfully', false);
        }
        handleClose(false);
        setFilePath(null);
        setIsSaving(false);

      })
      .catch((err) => {
        notify(err.toString(), true);
        setIsSaving(false);
        handleClose(false);
      });
  };

  const emptyCall = () => {
    getBatchData();
  };

  useEffect(() => {
    setCurrentSubject(currentData?.subjectId || "")
    getBatchData();
  }, []);

  useEffect(() => {
    if (currentData) {
      let temp = {};
      currentData.batch.forEach((item) => {
        temp[item.batchID] = true;
      });
      setSelectedBatchCheckbox(temp);
    }
  }, [currentData]);

  const isVideo = (file) => {
    var allowedExtensions = /(.mp4)$/i;
    return allowedExtensions.test(file?.name);
  };

  const handleFileUpload = (e) => {
    let fileSize = parseFloat(e[0]?.size / 1024 / 1024).toFixed(2);
    if (!isVideo(e[0])) {
      notify('Only mp4 files supported', true);
      if (e.target.value !== '') {
        e.target.value = '';
      }
      return;
    }
    if (fileSize > 1024) {
      notify('Maximum file size 1GB', true);
      if (e.target.value !== '') {
        e.target.value = '';
      }
      return;
    }
    setFileTitle(e[0].name);
    setFileUploading(true);
    var formData = new FormData();
    formData.append('file', e[0]);
    api({ path: '/upload', data: formData })
      .then((res) => {
        setFilePath(res?.data?.file);
        setFileUploading(false);
        notify('File Uploaded', false);
      })
      .catch((err) => {
        notify('File upload error occured', true);
        setFileUploading(false);
      });
  };

  const deleteFile = (fileName) => {
    let fileData = fileName.split('/');
    const data = {
      filename: fileData[1],
    };
    api({ path: '/upload/deleteFile', data: data })
      .then((res) => {
        setFilePath(null);
      })
      .catch((err) => {
        console.log('Media Error', err);
      });
  };

  const handleDialogClose = () => {
    if (currentData) {
      fileUploading
        ? notify('Please wait till we upload file', true)
        : !filePath
          ? notify('Please select file', true)
          : handleClose(false);
    } else {
      fileUploading
        ? notify('Please wait till we upload file', true)
        : handleClose(false);
    }
  };

  const onFileInputChange = (event) => {
    event.preventDefault();
    const { files } = event.target;
    handleFileUpload(files);
  };

  const onTargetClick = () => {
    browseBtnRef.current.click();
  };

  return (
    <div
      style={{
        backgroundColor: '#1f1e2e',
        height: '100%',
        overflowY: 'scroll',
      }}
    >
      {progressVisible && (
        <Progress color='info' value={progressValue} style={{ height: 4 }} />
      )}
      <div className='react-notification-alert-container'>
        <NotificationAlert ref={notifi} />
      </div>
      <div style={{ padding: '5px 20px' }}>
        <Row style={{ justifyContent: 'flex-end' }}>
          <IconButton
            edge='start'
            style={{ color: 'white' }}
            onClick={() => {
              handleDialogClose();
            }}
            aria-label='close'
          >
            <CloseIcon />
          </IconButton>
        </Row>

        <Row>
          <Col md='12'>
            <Card>
              <CardBody>
                <Row>
                  <Col
                    sm={{ size: 6 }}
                    style={{
                      display: 'flex',
                      height: '85vh',
                      flexDirection: 'column',
                      borderRight: '1px solid #3d4356',
                      paddingLeft: '6%',
                      paddingRight: '6%',
                      paddingTop: '5px',
                    }}
                  >
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div style={{ paddingBottom: '5px' }}>
                        <h5 className='title' style={{ marginBottom: 5 }}>
                          Topic Name*
                        </h5>
                        <input
                          className='form-control'
                          type='text'
                          name='title'
                          placeholder='Media Title'
                          {...register('title', { required: true })}
                        />
                        {errors?.title && errors?.title.type === 'required' && (
                          <span style={{ fontSize: '10px', color: 'red' }}>
                            Please enter Topic name
                          </span>
                        )}
                      </div>
                      <div style={{ paddingBottom: '5px' }}>
                        <h5 className='title' style={{ marginBottom: 5 }}>
                          Subject*
                        </h5>
                        <select
                          id='subject'
                          className='form-control'
                          {...register('lectureSubject', {
                            required: 'Please select a subject',
                          })}
                          style={{
                            height: '40px',
                            border: '1px solid rgb(42.67, 52.71, 82.83)',
                            borderRadius: '4px',
                            padding: '5px 10px',
                          }}
                        >
                          <option value=''>Select Subject</option>
                          {fetchSubject?.map((subject) => (
                            <option key={subject.id} value={subject.id}>
                              {subject.name}
                            </option>
                          ))}
                        </select>
                        {errors?.lectureSubject && (
                          <span style={{ fontSize: '10px', color: 'red' }}>
                            {errors?.lectureSubject.message}
                          </span>
                        )}
                      </div>
                      <div style={{ paddingBottom: '5px' }}>
                        <h5 className='title' style={{ marginBottom: 5 }}>
                          Lecture Date*
                        </h5>
                        <input
                          className="form-control dateTimePicker"
                          type="date"
                          name="lectureDate"
                          defaultValue={
                            currentData?.lectureDate
                              ? format(new Date(currentData.lectureDate), "yyyy-MM-dd")
                              : format(new Date(), "yyyy-MM-dd")
                          }
                          placeholder="lectureDate"
                          {...register("lectureDate", {
                            required: "Please select lecture date",
                            max: {
                              value: format(new Date(), "yyyy-MM-dd"), // Correct max value format
                              message: "Lecture date cannot be greater than today.",
                            },
                          })}
                          max={format(new Date(), "yyyy-MM-dd")}
                        />
                        {errors?.lectureDate && (
                          <span style={{ fontSize: '10px', color: 'red' }}>
                            {errors.lectureDate.message}
                          </span>
                        )}
                      </div>
                      <div style={{ paddingBottom: '5px' }}>
                        <h5 className='title' style={{ marginBottom: 5 }}>
                          Expiry Date*
                        </h5>
                        <input
                          className='form-control'
                          type='datetime-local'
                          name='expiryDate'
                          placeholder='expiryDate'
                          {...register('expiryDate', { required: true })}
                          min={format(new Date(), "yyyy-MM-dd'T'00:00")} 
                          defaultValue={
                            currentData.expiryDate ||
                            new Date(currentData.expiryDate) ||
                            new Date()
                          }
                        />
                        {errors?.expiryDate &&
                          errors?.expiryDate.type === 'required' && (
                            <span style={{ fontSize: '10px', color: 'red' }}>
                              Please enter expiry date
                            </span>
                          )}
                      </div>
                      {fileUploading ? (
                        <div className='uploadLoading'>
                          <CircularProgress style={{ color: '#FFF' }} />
                          <h6>Uploading...</h6>
                        </div>
                      ) : filePath ? (
                        <div className='filePathName'>
                          <h6>FileName</h6>
                          <div className='videoTitleRow'>
                            <MovieIcon style={{ color: '#FFF' }} />
                            <h6 style={{ marginLeft: 15, marginTop: 8 }}>
                              {filePath}
                            </h6>
                            <IconButton
                              style={{ marginLeft: 30 }}
                              onClick={() => deleteFile(filePath)}
                            >
                              <CloseIcon style={{ color: '#FFF' }} />{' '}
                            </IconButton>
                          </div>
                        </div>
                      ) : (
                        <div
                          className='uploadFileContainer'
                          style={{ cursor: 'pointer' }}
                        >
                          <FileDrop
                            onTargetClick={onTargetClick}
                            onDrop={(files, event) => {
                              event.preventDefault();
                              handleFileUpload(files);
                            }}
                          >
                            <BackupIcon
                              style={{ fontSize: 70, color: '#FFF' }}
                            />
                            <input
                              className='form-control'
                              type='file'
                              id='file'
                              accept='video/*'
                              ref={browseBtnRef}
                              onChange={onFileInputChange}
                              style={{ display: 'none' }}
                            />
                            <span style={{ color: '#FFF' }}>
                              Click here to browse or drag and drop a file*
                            </span>
                          </FileDrop>
                        </div>
                      )}
                      {selectedBatch && selectedBatch.length !== 0 && (
                        <Button color='info' style={{ marginTop: 5 }} disabled={isSaving}>
                          {!isSaving ? 'Save' : 'Saving...'}
                        </Button>
                      )}
                    </form>
                  </Col>
                  <Col
                    sm={{ size: 6 }}
                    style={{ borderRight: '1px solid #3d4356' }}
                  >
                    <div style={{ paddingLeft: 50 }}>
                      <h5 className='title'>Batches</h5>
                      <div style={{ display: 'flex' }}>
                        <div>
                          <input
                            className='form-control'
                            type='text'
                            name='search'
                            placeholder='Search'
                            style={{ marginRight: 0, minWidth: '250px' }}
                            onChange={(e) => {
                              setBatchSearchValue(e.target.value);
                              e.target.value.length === 0 && emptyCall();
                            }}
                          />
                        </div>
                        <div style={{ paddingLeft: '0px' }}>
                          <Button
                            style={{
                              margin: 0,
                              marginLeft: '10px',
                              padding: '6px 10px',
                            }}
                            color='info'
                            onClick={batchSearch}
                          >
                            <SearchIcon />
                          </Button>
                        </div>
                      </div>
                      <div style={{ height: '70vh', overflowY: 'scroll' }}>
                        <Table className='tablesorter'>
                          <thead className='text-primary'>
                            <tr>
                              <th>Name</th>
                            </tr>
                          </thead>
                          <tbody>
                            {batchData.map((item) => {
                              return (
                                <tr key={item.itemID}>
                                  <td style={{ paddingLeft: 12 }}>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name='checkBox'
                                          color='primary'
                                          classes={{ root: classes.root }}
                                          defaultChecked={
                                            selectedBatchCheckbox[
                                            item.itemID
                                            ] || false
                                          }
                                          onChange={(e) =>
                                            e.target.checked
                                              ? (setSelectedBatch([
                                                ...selectedBatch,
                                                {
                                                  batchID: item.itemID,
                                                  batchName: item.batchName,
                                                },
                                              ]),
                                                getBatchStudents(item.itemID),
                                                setSelectedBatchCheckbox(
                                                  (prev) => ({
                                                    ...prev,
                                                    [item.itemID]:
                                                      !prev[item.itemID],
                                                  })
                                                ))
                                              : (setSelectedBatch(
                                                selectedBatch.filter((id) => {
                                                  return (
                                                    id.batchID !== item.itemID
                                                  );
                                                })
                                              ),
                                                removeBatch(item.itemID),
                                                setSelectedBatchCheckbox(
                                                  (prev) => ({
                                                    ...prev,
                                                    [item.itemID]:
                                                      !prev[item.itemID],
                                                  })
                                                ))
                                          }
                                        />
                                      }
                                      label={item.batchName}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default MediaDialog;
